import React from 'react';
import { Helmet } from 'react-helmet-async';
import PageHeader from '../components/PageHeader';

function CaseStudies() {
	return (
		<>
			<Helmet>
				<title>Case Studies • Appex Connect Hub</title>
				<meta name="description" content="Selected outcomes from compliant, consent-first campaigns across finance verticals." />
			</Helmet>
			<PageHeader title="Case Studies" subtitle="Real outcomes from compliant outreach and construction-focused programs." />
			<section className="section">
				<div className="container">
				<div className="grid">
					<div className="card" style={{ padding: 18 }}>
						<h3>Equipment Finance Campaign</h3>
						<p className="helper">
							A regional lender improved contact rates by 22% leveraging explicit opt-in and clarified SMS disclosures.
						</p>
					</div>
					<div className="card" style={{ padding: 18 }}>
						<h3>Consumer Auto Finance</h3>
						<p className="helper">
							SMS + email touchpoints with STOP/HELP support reduced complaints and increased conversions by 14%.
						</p>
					</div>
					<div className="card" style={{ padding: 18 }}>
						<h3>Remodeling Lead Flow</h3>
						<p className="helper">
							Contractor network saw faster appointment confirmations using compliant SMS appointment reminders and opt-out tracking.
						</p>
					</div>
					<div className="card" style={{ padding: 18 }}>
						<h3>Solar Outreach</h3>
						<p className="helper">
							Clear disclosures and consent capture improved deliverability and maintained low spam complaints while scaling outreach.
						</p>
					</div>
				</div>
				</div>
			</section>
		</>
	);
}

export default CaseStudies;


